import { motion } from "framer-motion";
import { ASSETS } from "@/data";

export default function QuoteBanner() {
  return (
    <section data-testid="quote-section" className="relative py-24 md:py-36 overflow-hidden bg-foreground">
      <img
        src={ASSETS.feynman}
        alt="Καθηγητής φυσικής σε πανεπιστημιακό αμφιθέατρο"
        className="absolute inset-0 w-full h-full object-cover opacity-30"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground via-foreground/85 to-foreground/40" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl"
        >
          <div className="font-mono-accent text-xs uppercase tracking-[0.2em] text-accent mb-6">// Η φιλοσοφία της μάθησης</div>
          <blockquote className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.1] text-white">
            «Η γνώση δεν είναι δωρεάν — πρέπει να δώσεις προσοχή.»
          </blockquote>
          <p className="mt-6 font-mono-accent text-sm uppercase tracking-widest text-white/60">
            Knowledge isn't free — you have to pay attention.
          </p>
          <p className="mt-8 font-heading text-lg font-bold text-white">
            — Richard Feynman
          </p>
          <p className="font-mono-accent text-[11px] uppercase tracking-widest text-white/50 mt-1">
            Νόμπελ Φυσικής 1965
          </p>
        </motion.div>
      </div>
    </section>
  );
}
